import { makeAutoObservable } from 'mobx';
import 'core-js/features/object/from-entries';

export interface IPaywallStore {
	settings: IPaywallSettings;
	setSearchParams: (params: URLSearchParams) => void;
	setHideOptionPrices: (value: boolean) => void;
}

interface IPaywallSettings {
	isHideOptionPrices: boolean;
}

export class PaywallStore implements IPaywallStore {
	settings: IPaywallSettings;

	constructor(params: URLSearchParams, storage: Storage) {
		makeAutoObservable(this);
		this.settings = getSettings(params);
	}

	setSearchParams = (searchParams: URLSearchParams): void => {
		this.settings = getSettings(searchParams);
	};

	setHideOptionPrices = (value: boolean): void => {
		this.settings = {
			...this.settings,
			isHideOptionPrices: value,
		};
	};
}

const getSettings = (searchParams: URLSearchParams): IPaywallSettings => {
	const sourceParameters = Object.fromEntries(searchParams.entries());

	return {
		isHideOptionPrices: sourceParameters.hideOptionPrices === 'true',
	};
};
